import { render, staticRenderFns } from "./act004-quiz-dialog.vue?vue&type=template&id=bd546034&scoped=true"
import script from "./act004-quiz-dialog.vue?vue&type=script&lang=js"
export * from "./act004-quiz-dialog.vue?vue&type=script&lang=js"
import style0 from "./act004-quiz-dialog.vue?vue&type=style&index=0&id=bd546034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd546034",
  null
  
)

export default component.exports